var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-content',[_c('the-breadcrumb',{attrs:{"layout-class":"pl-3 pb-0"}}),_c('v-container',{attrs:{"fluid":""}},[_c('v-slide-y-transition',{attrs:{"mode":"out-in"}},[_c('router-view')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }